import { h } from "hyperapp";

import { columnSelector } from "../../common/column-selector/column-selector";
import { keywordFilter } from "../../common/keyword-filter/main";
import { actionsOnSelected } from "../../common/list-item-selector/actions-on-seleted";
import { pagination } from "../../common/pagination/pagination";
import { regionLoading } from "../../common/region-loading/region-loading";
import { controls } from "./controls";
import { list } from "./list";

export const main = ({
  actions,
  section,
  state,
  translations,
}): JSX.Element => {
  const {
    clientID,
    unvisitedPlaces: { category, since, portifolio: unvisitedPlacesPortifolio },
    portifolios,
    loadingPortifolios,
    unvisitedPlacesNearby: {
      coordinates,
      lastFetch: {
        failed,
        lastFailure,
        reason: { message },
      },
      name,
      loadingUnvisitedPlacesNearby,
      pagination: {
        currentPageNumber,
        currentPageSize,
        isLoading,
        itemCount,
        pageCount,
        pageNumber,
        pageNumberInvalid,
        pageSize,
      },
      portifolio,
      radius,
      isLoaded,
    },
  } = state;

  const firstPageLoad = () => {
    const unvisitedPlacesNearby = { ...state.unvisitedPlacesNearby };

    const unvisitedPlacesNearbyIsEmpty =
      Array.isArray(unvisitedPlacesNearby.items) &&
      unvisitedPlacesNearby.items.length <= 0;

    const receivedCoordinates = coordinates.split(",");

    const hasCoordinates =
      !!Number(receivedCoordinates[0]) && !!Number(receivedCoordinates[1]);

    if (
      unvisitedPlacesNearbyIsEmpty &&
      !loadingUnvisitedPlacesNearby &&
      hasCoordinates &&
      !isLoaded
    ) {
      actions.fetchUnvisitedPlacesNearby();
    }
  };

  return (
    <div class="container-fluid d-flex flex-column flex-md-column flex-lg-row flex-xl-row p-3 overflow-hidden">
      {/* filters */}
      <div class="d-flex flex-column col-auto col-md-auto col-lg-3 col-xl-2">
        <div class="card">
          <div class="card-body">
            <h5 class="card-title">{translations["places"]}</h5>
            {controls({
              translations,
              actions,
              section,
              state: {
                category,
                clientID,
                coordinates,
                loadingPortifolios,
                loadingUnvisitedPlacesNearby,
                name,
                pageNumber,
                pageSize,
                portifolioID: unvisitedPlacesPortifolio
                  ? unvisitedPlacesPortifolio.id
                  : portifolio
                  ? portifolios.id
                  : undefined,
                portifolios,
                radius,
                since,
              },
            })}
          </div>
        </div>
        {failed && (
          <div
            class="alert alert-danger animated pulse"
            key={`fetchUnvisitedPlacesNearbyFailed::${lastFailure}`}
            role="alert"
          >
            {message}
          </div>
        )}
        <div class="mb-2 mt-2" />
      </div>
      {/* content */}
      <div class="d-flex flex-column col-auto col-md-auto col-lg-9 col-xl-10">
        <div class="d-flex flex-column flex-md-row align-items-center ml-0 mr-0">
          <div class="col-md-4 col-lg-4 col-sm-12 p-0 mb-3 mb-md-0">
            {keywordFilter({
              translations,
              onChanged: ({ keyword }) => {
                if (keyword === state.unvisitedPlacesNearby.keyword) return;
                actions.setUnvisitedPlacesNearbyKeyword({ keyword });
                actions.fetchUnvisitedPlacesNearby();
                translations;
              },
            })}
          </div>
          <span class="flex-grow-1 d-sm-none d-md-block" />
          <div class="col-md-auto col-lg-auto col-xl-auto col-sm-12 p-0 mb-3 mb-md-0">
            {actionsOnSelected({
              onScheduleModalClosed: () => actions.fetchUnvisitedPlacesNearby(),
              section,
              state,
              translations,
            })}
          </div>
          <span class="mr-3 d-sm-none d-md-block" />
          <div class="col-md-auto col-lg-auto col-xl-auto col-sm-12 p-0 d-flex justify-content-end mb-3 mb-md-0">
            {columnSelector({
              translations,
              actions,
              disabled: loadingUnvisitedPlacesNearby,
              section,
              state,
            })}
          </div>
        </div>
        <div class="m-1" />
        <div class="position-relative">
          {list({ actions, section, state, translations })}
          {regionLoading({
            state: {
              on: loadingUnvisitedPlacesNearby,
            },
          })}
        </div>
        <div class="position-relative">
          {regionLoading({
            state: {
              on: isLoading,
            },
          })}
          <table class="col-12">
            <caption>
              {currentPageNumber > 0 && (
                <span class="caption">
                  {translations["location"]} <b>{name}</b>
                  <br />
                  <b>
                    {new Intl.NumberFormat("pt-BR").format(
                      (currentPageNumber - 1) * currentPageSize + 1,
                    )}
                  </b>{" "}
                  a{" "}
                  <b>
                    {new Intl.NumberFormat("pt-BR").format(
                      (currentPageNumber - 1) * currentPageSize +
                        currentPageSize <
                        itemCount
                        ? (currentPageNumber - 1) * currentPageSize +
                            currentPageSize
                        : itemCount,
                    )}
                  </b>{" "}
                  {itemCount === undefined ? (
                    <span />
                  ) : (
                    <span>
                      {" "}
                      de{" "}
                      <b>
                        {new Intl.NumberFormat("pt-BR").format(itemCount)}
                      </b>{" "}
                    </span>
                  )}
                </span>
              )}
            </caption>
          </table>
          {pagination({
            actions: {
              onChange: actions.fetchUnvisitedPlacesNearby,
              setPagination: actions.setPagination,
            },
            section,
            state: {
              currentPageNumber,
              disabled: loadingUnvisitedPlacesNearby,
              pageCount,
              pageNumber,
              pageNumberInvalid,
              pageSize,
            },
          })}
        </div>
      </div>
      {(window.onload = firstPageLoad)}
    </div>
  );
};
